module.exports = __webpack_public_path__ + "yeni ofis 11.jpeg?d7707a502695ec9b1685d21fbd6ce54a";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni ofis 11.jpeg
// module id = 386
// module chunks = 0